<template>
	<b-row>
		<b-col>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label class="mh-label">Policy</label>
						<div class="row">
							<div v-for="(policyRow, index) in policies"
								 :key="index"
								 :class="`col-md-6 policy-container${(policy == policyRow.id ? ' active' : '')}`"
								 @click="policy = policyRow.id">
								<div class="policy">
									<span class="name">{{policyRow.name}}</span>
									<span class="chargepercentage">{{policyRow.chargepercentage}}%</span>
									<span class="description">{{policyRow.description}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 mb-2">
					<div class="form-group">
						<label class="mh-label">Reason</label>
						<b-select v-model="reason" :options="reasons" text-field="name" value-field="id" />
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<div class="form-group">
						<label class="mh-label">Comments</label>
						<textarea class="form-control" v-model="comments"></textarea>
					</div>
				</div>
			</div>
			<b-row class="mh-action-nav">
				<b-col cols="6">
					<button class="btn btn-default btn-grey" @click="closeForm">Close</button>
				</b-col>
				<b-col cols="6">
					<button class="btn btn-default" @click="saveRecord">Cancel Shift</button>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
	export default {
		name: 'CancelShiftForm',
		props: {
			data: null
		},
		data: function () {
			return {
				serviceScheduleId: 0,
				policy: 0,
				reason: 0,
				comments: ""
			}
		},
		mounted: function () {
			this.serviceScheduleId = this.data.servicescheduleid
		},
		computed: {
			policies: function () {
				return this.$store.state.Shifts.cancellationPolicies
			},
			reasons: function () {
				return this.$store.state.Shifts.cancellationReasons
			},
			isServiceScheduleIdValid: function () {
				if (this.serviceScheduleId == null)
					return false

				return true
			}
		},
		methods: {
			closeForm: function () {
				this.$emit("close-form")
			},
			isFormValid: function () {
				return this.isServiceScheduleIdValid
			},
			saveRecord: function () {
				if (!this.isFormValid()) {
					this.$store.commit("Toasts/showError", { title: "Save Failed", content: "Please fill in all fields" })

					return
				}

				var parameters = {
					ids: this.serviceScheduleId,
					cancellationPolicyId: this.policy,
					cancellationReasonId: this.reason,
					comments: this.comments
				}

				var $this = this

				this.$store.dispatch("Shifts/cancelShifts", parameters).then(function () {
					$this.$emit("save-form")
				})
			}
		}
	}
</script>

<style scoped>
	.policy-container {
		margin-bottom: 10px;
	}

		.policy-container .policy {
			height: 100%;
			padding: 10px 15px;
			border-radius: 15px;
			background-color: #f7f8fa;
			cursor: pointer;
		}

		.policy-container.active .policy {
			filter: brightness(85%);
		}

			.policy-container .policy > span {
				display: inline-block;
				width: 100%;
			}

			.policy-container .policy .name {
				font-size: 15px;
				font-weight: bold;
			}

			.policy-container .policy .chargepercentage {
				font-size: 13px;
				font-weight: bold;
			}

			.policy-container .policy .description {
				font-size: 12px;
			}
</style>